export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M12.75 6.42h.75c.82 0 1.5.66 1.5 1.47v7.34c0 .81-.68 1.47-1.5 1.47h-9c-.83 0-1.5-.66-1.5-1.47V7.9c0-.81.67-1.47 1.5-1.47h.75V4.95A3.71 3.71 0 019 1.27a3.71 3.71 0 013.75 3.68v1.47zM6.67 4.95v1.47h4.65V4.95A2.3 2.3 0 009 2.67a2.3 2.3 0 00-2.33 2.28zM9 13.03c.83 0 1.5-.66 1.5-1.47 0-.81-.67-1.47-1.5-1.47s-1.5.66-1.5 1.47c0 .81.67 1.47 1.5 1.47z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "fill": "#EA3917",
    "viewBox": "0 0 18 18"
  }
};